import { FC } from 'react';
import s from './Links.module.css';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { LinksType } from 'Data/types';
import { myData } from 'Data/Data';

export const Links: FC = () => {
    const renderTooltip = (tooltip: LinksType) => (
        <Tooltip id={`tooltip-bottom`}>
            <strong>{tooltip.name}</strong>
        </Tooltip>
    );

    return (
        <div className={s.iconsLink}>
            {myData.links.map((link, key) => {
                return (
                    <a key={key} target="_blank" rel="noreferrer nopener" href={link.url}>
                        <OverlayTrigger
                            placement="bottom"
                            overlay={renderTooltip(link)}
                            defaultShow={false}
                        >
                            <i className={link.icon} />
                        </OverlayTrigger>
                    </a>
                );
            })}
        </div>
    );
};
